import { roles } from "../config/config";

export const imsPermissions = [roles.admin, roles.gestore, roles.developer];

export const getImsPermissions = (userIsAgente) => [
  ...imsPermissions,
  userIsAgente,
];
